import React from 'react';
import Table from 'react-bootstrap/Table';

export default class InfoUsuario extends React.Component {


    componentDidMount() {
    }

    render() {
        const {equipos} = this.props.usuario;

        return (
            <div style={{height: '100%', width: '100%'}}>
                <h5>Lista de equipos</h5>
                <Table striped bordered hover responsive>
                    <thead>
                    <tr>
                        <th>ID</th>
                        <th>Label</th>
                        <th>Tipo</th>
                    </tr>
                    </thead>
                    <tbody>
                    {equipos !== undefined && equipos.map((item, index) =>
                        <tr key={index}>
                            <td>{item.id}</td>
                            <td>{item.nombre}</td>
                            <td>{item.tipoEquipo ? item.tipoEquipo.descripcion : ''}</td>
                        </tr>
                    )}
                    </tbody>
                </Table>

            </div>
        );
    }
}